import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { UserImportRecord } from '../../core/api/models/user-import.model';
import { UserImportsApiService } from '../../core/api/services/user-imports-api.service';

@Component({
  selector: 'app-user-import-detail',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './user-import-detail.component.html',
  styleUrl: './user-import-detail.component.scss',
})
export class UserImportDetailComponent implements OnInit {
  private readonly api = inject(UserImportsApiService);
  private readonly route = inject(ActivatedRoute);

  record: UserImportRecord | null = null;
  loading = false;
  notFound = false;
  error = '';

  ngOnInit(): void {
    const publicId = this.route.snapshot.paramMap.get('publicId');
    if (!publicId) {
      this.notFound = true;
      return;
    }

    this.loading = true;
    this.api.getUserImport(publicId).subscribe({
      next: value => {
        this.record = value;
        this.loading = false;
      },
      error: response => {
        this.loading = false;
        this.notFound = response.status === 404;
        this.error = this.notFound ? '' : 'Could not load the imported-user details.';
      },
    });
  }

  roles(values: string[]): string {
    return values.length ? values.join(', ') : 'None';
  }
}
